import { ChangeEvent, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { PasswordPolicie } from '../../../../domain/shared';
import { UpdateUserPassword } from '../../../../domain/users/update-user-password';
import ssoClient from '../../../../infrastructure/http/ssoClient';
import { AppContext } from '../../../../main/context/Provider';

export const ChangePasswordController = (passwordPolicies: PasswordPolicie[]) => {
    const { langResources } = useContext(AppContext);

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [sendChange, setSendChange] = useState(false);

    const [changeSuccessfully, setChangeSuccessfully] = useState(false);

    const handlerChangecurrentPassword = (e: ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setCurrentPassword(value);

        passwordPolicies.forEach((policy) => {
            if (value !== confirmPassword) {
                if (policy.title === 'differentPasswords') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'differentPasswords') {
                    policy.status = false;
                }
            }
        });

        let isCorrectPassword = passwordPolicies.map((policy) => policy.status);

        if (isCorrectPassword.includes(false)) {
            setSendChange(false);
        } else {
            setSendChange(true);
        }
    };

    const handlerChangeNewPassword = (e: ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setNewPassword(value);

        passwordPolicies.forEach((policy) => {
            if (policy.regex) {
                if (new RegExp(policy.regex).test(value)) {
                    policy.status = true;
                } else {
                    policy.status = false;
                }
            }

            if (value === confirmPassword) {
                if (policy.title === 'confirmPassword') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'confirmPassword') {
                    policy.status = false;
                }
            }

            if (value !== currentPassword) {
                if (policy.title === 'differentPasswords') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'differentPasswords') {
                    policy.status = false;
                }
            }
        });

        let isCorrectPassword = passwordPolicies.map((policy) => policy.status);

        if (isCorrectPassword.includes(false)) {
            setSendChange(false);
        } else {
            setSendChange(true);
        }
    };

    const handlerChangeConfirmPassword = (e: ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setConfirmPassword(value);

        passwordPolicies.forEach((policy) => {
            if (policy.regex) {
                if (new RegExp(policy.regex).test(value)) {
                    policy.status = true;
                } else {
                    policy.status = false;
                }
            }

            if (value !== currentPassword) {
                if (policy.title === 'differentPasswords') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'differentPasswords') {
                    policy.status = false;
                }
            }

            if (value === newPassword) {
                if (policy.title === 'confirmPassword') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'confirmPassword') {
                    policy.status = false;
                }
            }
        });

        let isCorrectPassword = passwordPolicies.map((policy) => policy.status);

        if (isCorrectPassword.includes(false)) {
            setSendChange(false);
        } else {
            setSendChange(true);
        }
    };

    const handlerSavePassword = () => {
        let body: UpdateUserPassword = {
            newPassword,
            currentPassword,
        };

        if (sendChange) {
            try {
                ssoClient.changePassword(body).then((response) => {
                    setChangeSuccessfully(true);
                    setCurrentPassword('');
                    setNewPassword('');
                    setConfirmPassword('');
                });
            } catch (error) {
                toast.warning(
                    langResources['profile.page']['message.alert.change.password'],
                    {
                        autoClose: 5000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    }
                );
            }
        } else {
            toast.error(
                langResources['profile.page']['message.failed.change.password'],
                {
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
        }
    };

    return {
        currentPassword,
        changeSuccessfully,
        newPassword,
        confirmPassword,
        sendChange,
        handlerChangecurrentPassword,
        handlerChangeNewPassword,
        handlerChangeConfirmPassword,
        handlerSavePassword,
    };
};
